export enum HdrType {
  Undefined = "Undefined",
  DolbyVision = "DolbyVision",
  HDR10 = "HDR10",
  HDR10Plus = "HDR10Plus",
  HLG = "HLG",
  None = "None",
}
